import React from 'react';
import { useSnackbar } from '../SnackBar';
import { usePartnerContext } from '../../components/Context/PartnerContext';
import { useNavigate,useParams } from 'react-router-dom';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useState,useEffect,useRef } from 'react';
import { use } from 'react';
import ConfirmDialog from '../ConfirmDialog';
import EditDialogBodyType from '../EditDialog/EditDialogBodyType';
const Coupansedit=()=>{
    const styles = { inputDisabled: { border: 'none', background: 'none' } };
    const userType = localStorage.getItem('userType');
    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const {id,edit} = useParams();
    const didFetch=useRef(false);
    const [loading ,setLoading] =useState(true);
    const {GetCoupansById,updateCouponStataus,deleteCoupon}=useServiceContext();
    const [data, setData] =useState(null);
    const [approved, setApproved] = useState(false);
    const [editType, setEditType] = useState('');
         const getData=async() =>{
             try{
                 const d=await GetCoupansById(id);
                 setData(d); 
                 setLoading(false);
             }catch(error){
                 console.log(error);
             } 
            
         }
         useEffect(()=>{
            
                 if(!didFetch.current){
                     getData();
                     didFetch.current=true;
                 }
                 console.log(didFetch);
         },[id, GetCoupansById]);
         useEffect(() => { if (data) { console.log(JSON.stringify(data)); } },[data]);
         const[confirmOpen,setConfirmOpen]=useState(false);
         const[confirmOpen1,setConfirmOpen1]=useState(false);
         const[pendingStatus,setPendingStatus]=useState(null);
         const [editOpen, setEditOpen] = useState(false);
         const [open, setOpen] = useState(false);
        const handleActive=(event)=>{
            const isActive=event.target.checked;
            setPendingStatus(isActive);
            setConfirmOpen1(true); 
        } 
        const handleClose = () => {
            setOpen(false); // Close the confirmation dialog 
        };
        const handleConfirmStatusChange = async () => {
            const value = pendingStatus ? 'true' : 'false';
            const coupanId = data.id;
    debugger;
            data.isActive = pendingStatus; // Update the branch status locally
            updateCouponStataus(coupanId,value)
            //showSnackbar(`Branch ${pendingStatus ? 'Activated' : 'Deactivated'} Successfully`);
           setConfirmOpen1(false); // Close the dialog
        };
        const handelEdit = () => {
            // Navigate to the edit form with the branch ID
            navigate(`/CoupansEditData/${data.id}/true`, { state: { coupans: data } });
        };
        const handleDeleteClick = () => {
            setConfirmOpen(true); // Open the confirmation dialog
        };
        const handleConfirmClose = () => {
            setConfirmOpen(false); // Close the confirmation dialog
        };
        const handleConfirmDelete = async () => {
            setConfirmOpen(false); // Close the confirmation dialog
            if (data.id) {
              debugger;
              deleteCoupon(data.id);
              showSnackbar('Coupon deleted successfully', 'success');
              navigate('/couponlist');// Delete the selected brand
            }
        
        };
        const handleActiveDeactive = async (event) => {
            setConfirmOpen1(false); // Close the confirmation dialog
            if (data.id) {
              debugger;
               const isActive = event.target.checked;
               data.
              //deleteBranch(branchData.id);
              showSnackbar('Coupon status changed successfully', 'success');
              //navigate('/newbranch');// Delete the selected brand
            }
        
        };
        const handleConfirm = async () => {
            try {
                //await ApproveBranchById(branchData);
                //Data.isApproved = true;
    
                showSnackbar('Coupon approved successfully');
                setApproved(true);
                setOpen(false); // Close the dialog after successful confirmation
            } catch (error) {
                console.error('Error approving branch:', error);
            }
        };
        const handleApproveClick = () => {
            setOpen(true); // Open the confirmation dialog
        };


return(
   <div> {didFetch.current && <main id="main" className="main">
    <div className="pagetitle">
      <h1>Coupon Details</h1>
        <nav>
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/CoupanList">Coupon List</a></li>
                
            </ol>
        </nav>
    </div>
    <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Coupans Details</h5>
                                <form>
                                    <div className="container">
                                         <div className="row mb-3">
                                            <nav className="navbar navbar-expand-lg navbar-light">
                                                <div className="container-fluid">
                                                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                                            </ul>
                                                                {userType != "ADMIN" && <>
                                                                    <Button className="right-button me-2"
                                                                            variant="contained"
                                                                             style={{ backgroundColor: '#02176D', color: 'white' }}
                                                                             onClick={handelEdit} 
                                                                             >
                                                                             Edit
                                                                     </Button>
                                                                    <Button
                                                                            variant="contained"
                                                                            style={{ backgroundColor: '#02176D', color: 'white' }}
                                                                            onClick={handleDeleteClick}
                                                                            className="right-button"
                                                                    >
                                                                        Delete Coupon
                                                                    </Button></>
                                                                }
                                                    </div>
                                                    </div>
                                            </nav>
                                                                 
                                    
                                            <div className="row mb-3">
                                                <label className="col-sm-2 col-form-label">Name</label>
                                                <div className="col-sm-6">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        style={styles.inputDisabled}
                                                        defaultValue={data.name}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-sm-2 col-form-label">Validity</label>
                                                <div className="col-sm-6">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        style={styles.inputDisabled}
                                                        defaultValue={data.validity}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-sm-2 col-form-label">ServicesOffered</label>
                                                <div className="col-sm-6">
                                                {data.serviceOffered && data.serviceOffered.length > 0 ? (
                                                     <ul> 
                                                        {data.serviceOffered.map((service, index) => ( 
                                                            <li key={index}>{service.serviceName}</li> ))} 
                                                     </ul> ) : ( <p>No services offered.</p> 
                                                )}
                                                    
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-sm-2 col-form-label">ServicesApplicable</label>
                                                <div className="col-sm-6">
                                                {
                                                    data.servicesApplicable && data.servicesApplicable.length > 0 ? ( 
                                                    <ul> {data.servicesApplicable.map((service, index) => ( 
                                                        <li key={index}>{service.serviceName} - Coupan Can Use : {service.availCount}times </li> ))} 
                                                    </ul> ) : ( <p>No services applicable.</p> )
                                                }

                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-sm-2 col-form-label">BranchesAvailable</label>
                                                <div className="col-sm-6">
                                                {data.branchesAvailable && data.branchesAvailable.length > 0 ? 
                                                    ( <ul>
                                                         {  
                                                             data.branchesAvailable.map((branch, index) => (
                                                             <li key={index}>{branch.branchName} - {branch.streetName}</li> ))
                                                         } 
                                                             
                                                      </ul> ) : ( <p>No branches available.</p> )
                                                }
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-sm-2 col-form-label">Coupan Status</label>
                                                <div className="col-sm-6">
                                            
                                                    <div className="form-check form-switch">
                                                
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="flexSwitchCheckDefault"
                                                        checked={data.isActive}
                                                        onChange={handleActive}
                                                    />
                                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Active</label>
                                                
                                                        <div className="col-sm-4">
                                                            {//(!(data.isActive)) && (
                                                             //userType === 'ADMIN' && (
                                                                 // <button type="button" className="btn btn-primary" onClick={handleApproveClick}>
                                                                    // Approve
                                                                //</button>
                                                                //)
                                                            }
                                                        </div>
                                                    
                                              
                                                </div>  
                                                            
                                            
                                             </div>
                                            </div>
                                            
                                            {/* Confirmation Dialog */}
                                                <Dialog open={confirmOpen1} onClose={() => setConfirmOpen1(false)}>
                                                    <DialogTitle>Confirm Status Change</DialogTitle>
                                                        <DialogContent>
                                                             <DialogContentText>
                                                                Are you sure you want to {pendingStatus ? 'activate' : 'deactivate'} this Coupan?
                                                            </DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions>
                                                            <Button onClick={() => setConfirmOpen1(false)} color="secondary">
                                                                 Cancel
                                                            </Button>
                                                            <Button onClick={handleConfirmStatusChange} color="primary" autoFocus>
                                                                Confirm
                                                            </Button>
                                                        </DialogActions>
                                                </Dialog>
                                             {/* Delete Button */}
                    {/* Confirmation Dialog */}
                    <Dialog open={confirmOpen} onClose={handleConfirmClose}>
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are you sure you want to delete this branch? This action cannot be undone.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleConfirmClose} color="secondary">
                                Cancel
                            </Button>
                            <Button onClick={handleConfirmDelete} color="primary" autoFocus>
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>
              {/* Confirmation Dialog */}
                                                            <ConfirmDialog
                                                                isOpen={open}
                                                                onClose={handleClose}
                                                                onConfirm={handleConfirm}
                                                                title="Confirm Approval"
                                                                content="Are you sure you want to approve this branch?"
                                                            />
                                                            <EditDialogBodyType
                                                                open={editOpen}
                                                                handleClose={() => setEditOpen(false)}
                                                                type={editType}
                                                                currentData={data} // Pass branch data here if needed
                                                                handleSave={handleApproveClick}
                                                            />
                                
                                </div>
                            </div>
                        
                        </form>
                    </div>
                </div>
                </div>   
                                        <div>
                                    </div>
                                    </div>
            </section>
        </main>
    }
    </div> 
       
    );
}
export default Coupansedit